import { Component, OnInit, ViewChild } from '@angular/core';
import { HelpersService } from '../../../../services/helpers.service';
import { PartnerService } from '../../../../services/partner.service';
import { Paginator } from 'primeng/paginator';
import { ThirdPartyService } from '../../../../services/thirdparty.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-third-party',
  templateUrl: './third-party.component.html',
  styleUrls: ['./third-party.component.scss'],
  providers: [MessageService],
})
export class ThirdPartyComponent implements OnInit {
  public partnerID: any;
  public loading: boolean = false;
  public thirdParties: any = [];
  public search: string = '';
  public page: number = 0;
  public limit: number = 15;
  public totalRecords: number = 0;
  public columns: any = [{ header: 'Name', field: 'Name', type: 'string' }];

  public showThirdParty: boolean = false;
  public selectedThirdParty: any = {};

  public editing: boolean = false;

  public combinedServicesUsed: any;

  @ViewChild('paginator') paginator: Paginator;

  constructor(
    private partnerService: PartnerService,
    public helpersService: HelpersService,
    public thirdPartyService: ThirdPartyService,
    public messageService: MessageService,
  ) {}

  ngOnInit() {
    this.partnerID = this.helpersService.getPartnerId();

    this.getThirdParties();
  }

  getThirdParties() {
    this.loading = true;

    this.thirdPartyService
      .getThirdParties(this.partnerID)
      .subscribe((result) => {
        console.log(result);
        this.thirdParties = result.map((item) => {
          return item;
        });

        this.loading = false;

        this.updateUsedServiceTypesList();
      });
  }

  closeSidePanel(newData) {
    if (newData != null) {
      console.log('closeSidePanel');
      console.log(newData);
      let indexToUse = this.thirdParties.findIndex(
        (thirdParty) => thirdParty.id === newData.id,
      );
      if (newData.status) {
        //Deleted
        if (indexToUse !== -1) {
          this.thirdParties.splice(indexToUse, 1);
        }
      } else {
        //Added/Updated
        if (indexToUse !== -1) {
          //Update
          this.thirdParties[indexToUse].name = newData.name;
          this.thirdParties[indexToUse].servicesLinked = newData.servicesLinked;
          this.thirdParties[indexToUse].contactName = newData.contactName;
          this.thirdParties[indexToUse].address = newData.address;
          this.thirdParties[indexToUse].willPay = newData.willPay;
          this.thirdParties[indexToUse].image = newData.image;
        } else {
          //Add
          this.thirdParties.push({
            id: newData.id,
            servicesLinked: newData.servicesLinked,
            contactName: newData.contactName,
            address: newData.address,
            willPay: newData.willPay,
            image: newData.image,
          });
        }
      }

      this.getThirdParties();

      this.updateUsedServiceTypesList();
    }

    this.selectedThirdParty = {};
    this.showThirdParty = false;
    this.editing = false;
  }

  updateUsedServiceTypesList() {
    this.combinedServicesUsed = Array.from(
      new Set(
        this.thirdParties.reduce(
          (accumulator, record) => accumulator.concat(record.servicesLinked),
          [],
        ),
      ),
    );
  }

  addNewThirdParty() {
    this.selectedThirdParty = {};
    this.editing = false;
    this.showThirdParty = true;
  }

  editThirdParty(thirdPartyID) {
    console.log(thirdPartyID);

    // Swal.fire({
    //   title: 'Loading',
    //   showCancelButton: false,
    //   showConfirmButton: false,
    //   allowOutsideClick: false,
    // });

    this.thirdPartyService
      .getThirdParty(this.partnerID, thirdPartyID)
      .subscribe(
        (result) => {
          console.log(result);
          //Swal.close();
          this.editing = true;
          this.selectedThirdParty = result;
          this.showThirdParty = true;
        },
        (err) => {
          //Swal.close();
        },
      );
  }
}
